<script setup lang="ts">
import {
    LazyContentPricingBuyerCs,
    LazyContentPricingBuyerDe,
    LazyContentPricingBuyerEn,
    LazyContentPricingBuyerEs,
    LazyContentPricingBuyerFr,
    LazyContentPricingBuyerIt,
    LazyContentPricingBuyerNl,
    LazyContentPricingBuyerPl,
    LazyContentPricingBuyerPt,
    LazyContentPricingBuyerRo,
    LazyContentPricingBuyerRu,
} from '#components';
import { Locale } from '~i18n/i18nConfig';

// COMPOSABLES
const { locale, tt } = useTypedI18n();
useSeoMeta({
    title: tt('seo.pricingBuyer.title'),
    ogTitle: tt('seo.pricingBuyer.title'),
    description: tt('seo.pricingBuyer.description'),
    ogDescription: tt('seo.pricingBuyer.description'),
});

// DATA
const currentComponent = computed<Component>(() => {
    const componentByLocale: Record<Locale, Component> = {
        [Locale.CS]: LazyContentPricingBuyerCs,
        [Locale.DE]: LazyContentPricingBuyerDe,
        [Locale.EN]: LazyContentPricingBuyerEn,
        [Locale.ES]: LazyContentPricingBuyerEs,
        [Locale.FR]: LazyContentPricingBuyerFr,
        [Locale.IT]: LazyContentPricingBuyerIt,
        [Locale.NL]: LazyContentPricingBuyerNl,
        [Locale.PL]: LazyContentPricingBuyerPl,
        [Locale.PT]: LazyContentPricingBuyerPt,
        [Locale.RO]: LazyContentPricingBuyerRo,
        [Locale.RU]: LazyContentPricingBuyerRu,
    };

    return componentByLocale[locale.value];
});
</script>

<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>
